export const enum vehicleConstants {
  // Get Vehicles
  getVehicleRequest = "GET_VEHICLE_REQUEST",
  getVehicleSuccess = "GET_VEHICLE_SUCCESS",
  getVehicleFailure = "GET_VEHICLE_FAILURE",

  // Create Vehicle
  vehicleCreateRequest = "VEHICLE_CREATE_REQUEST",
  vehicleCreateSuccess = "VEHICLE_CREATE_SUCCESS",
  vehicleCreateFailure = "VEHICLE_CREATE_FAILURE",

  // Get Vehicles with params (pagination/search)
  getVehicleParamsRequest = "GET_VEHICLE_PARAMS_REQUEST",
  getVehicleParamsSuccess = "GET_VEHICLE_PARAMS_SUCCESS",
  getVehicleParamsFailure = "GET_VEHICLE_PARAMS_FAILURE",

  // Delete Vehicle
  vehicleDeleteRequest = "VEHICLE_DELETE_REQUEST",
  vehicleDeleteSuccess = "VEHICLE_DELETE_SUCCESS",
  vehicleDeleteFailure = "VEHICLE_DELETE_FAILURE",

  // Toggle Vehicle (status)
  vehicleToggleRequest = "VEHICLE_TOGGLE_REQUEST",
  vehicleToggleSuccess = "VEHICLE_TOGGLE_SUCCESS",
  vehicleToggleFailure = "VEHICLE_TOGGLE_FAILURE",

  // Vehicle view
  vehicleViewRequest = "VEHICLE_VIEW_REQUEST",
  vehicleViewSuccess = "VEHICLE_VIEW_SUCCESS",
  vehicleViewFailure = "VEHICLE_VIEW_FAILURE",
  // Vehicle image upload
  vehicleUploadRequest = "VEHICLE_UPLOAD_REQUEST",
  vehicleUploadSuccess = "VEHICLE_UPLOAD_SUCCESS",
  vehicleUploadFailure = "VEHICLE_UPLOAD_FAILURE",

  // Trip Sheet
  tripSheetSaveRequest = "TRIP_SHEET_SAVE_REQUEST",
  tripSheetSaveSuccess = "TRIP_SHEET_SAVE_SUCCESS",
  tripSheetSaveFailure = "TRIP_SHEET_SAVE_FAILURE",

  tripSheetListRequest = "TRIP_SHEET_LIST_REQUEST",
  tripSheetListSuccess = "TRIP_SHEET_LIST_SUCCESS",
  tripSheetListFailure = "TRIP_SHEET_LIST_FAILURE",

  tripSheetViewRequest = "TRIP_SHEET_VIEW_REQUEST",
  tripSheetViewSuccess = "TRIP_SHEET_VIEW_SUCCESS",
  tripSheetViewFailure = "TRIP_SHEET_VIEW_FAILURE",

  tripSheetDeleteRequest = "TRIP_SHEET_DELETE_REQUEST",
  tripSheetDeleteSuccess = "TRIP_SHEET_DELETE_SUCCESS",
  tripSheetDeleteFailure = "TRIP_SHEET_DELETE_FAILURE",

  tripSheetByVehicleRequest = "TRIP_SHEET_BY_VEHICLE_REQUEST",
  tripSheetByVehicleSuccess = "TRIP_SHEET_BY_VEHICLE_SUCCESS",
  tripSheetByVehicleFailure = "TRIP_SHEET_BY_VEHICLE_FAILURE",

  tripSheetByBatchRequest = "TRIP_SHEET_BY_BATCH_REQUEST",
  tripSheetByBatchSuccess = "TRIP_SHEET_BY_BATCH_SUCCESS",
  tripSheetByBatchFailure = "TRIP_SHEET_BY_BATCH_FAILURE",
}
